import * as React from 'react';
import styled from "styled-components";
import Flickity from "react-flickity-component";
import '../Flickity.css';
import useImageViewer from "hooks/use-image-viewer";

interface TabletSliderProps {
  items: string[];
}

const Container = styled.div`
  width: 100%;
  max-width: 760px;
  min-width: 760px;
  height: 500px;
  border: 10px solid #29292B;
  background: #D1D5DC;
  border-radius: 20px;
  box-sizing: border-box;
  overflow: hidden;

  @media screen and (max-width: 1190px) {
    min-width: auto;
    max-width: 740px;
  }

  @media screen and (max-width: 790px) {
    min-width: auto;
    max-width: 560px;
    height: 420px;
  }

  @media screen and (max-width: 600px) {
    min-width: auto;
    max-width: 480px;
    height: 310px;
  }

  @media screen and (max-width: 505px) {
    min-width: auto;
    max-width: 300px;
    height: 200px;
  }
`;

const Box = styled.div`
  width: 100%;
  height: 500px;
  background: #222;

  @media screen and (max-width: 790px) {
    height: 420px;
  }

  @media screen and (max-width: 600px) {
    height: 310px;
  }

  @media screen and (max-width: 505px) {
    height: 200px;
  }
  
  img {
    width: 100%;
    object-fit: cover;
  }
`;

/**
 * render landing page image slider
 * @constructor
 */
export default function TabletSlider(
  props: TabletSliderProps
): React.ReactElement {
  const {openImageViewer} = useImageViewer();

  function openImage(e: React.MouseEvent, ind: number) {
    openImageViewer(props.items, ind)
  }

  function renderImage(src: string, index: number) {
    return (
      <Box key={index+src} onClick={(e) => openImage(e, index)}>
        <img src={src} alt=""/>
      </Box>
    )
  }

  return (
    <Container>
      <Flickity
        options={{
          arrowShape: {
            x0: 25,
            x1: 50, y1: 30,
            x2: 55, y2: 25,
            x3: 35
          },
          lazyLoad: 1,
          draggable: false,
          autoPlay: 4000,
          freeScroll: true,
          wrapAround: true,
        }}
      >
        {props.items.map(renderImage)}
      </Flickity>
    </Container>
  );
}
